
import { Component, Vue } from 'vue-property-decorator'
import { apiMerchantMenuAuthGet, apiMerchantMenuAuthSet, apiMerchantMenuAuthTree } from '@/api/setting'

@Component
export default class MerchantMenuAuth extends Vue {
  activeTab = 'mall'

  tree: any = {
    mall: [],
    mes: []
  }

  config: any = {
    menu_auth_mall: [],
    menu_auth_mes: []
  }

  treeProps = {
    label: 'label',
    children: 'children'
  }

  private getLeafAuthKeys (nodes: any[]): string[] {
    const result: string[] = []
    const dfs = (list: any[]) => {
      list.forEach((n) => {
        if (n?.auth_key) {
          result.push(n.auth_key)
        }
        if (Array.isArray(n?.children) && n.children.length) {
          dfs(n.children)
        }
      })
    }
    dfs(nodes || [])
    return result
  }

  private applyChecked () {
    const mallTree: any = this.$refs.mallTree
    const mesTree: any = this.$refs.mesTree
    if (mallTree) mallTree.setCheckedKeys(this.config.menu_auth_mall || [])
    if (mesTree) mesTree.setCheckedKeys(this.config.menu_auth_mes || [])
  }

  async init () {
    const [treeRes, cfgRes] = await Promise.all([apiMerchantMenuAuthTree(), apiMerchantMenuAuthGet()])
    this.tree = treeRes
    this.config = cfgRes
    this.$nextTick(() => this.applyChecked())
  }

  checkAll (type: 'mall' | 'mes') {
    const treeRef: any = type === 'mall' ? this.$refs.mallTree : this.$refs.mesTree
    const keys = this.getLeafAuthKeys(this.tree[type])
    treeRef && treeRef.setCheckedKeys(keys)
  }

  clearAll (type: 'mall' | 'mes') {
    const treeRef: any = type === 'mall' ? this.$refs.mallTree : this.$refs.mesTree
    treeRef && treeRef.setCheckedKeys([])
  }

  async onSubmit () {
    const mallTree: any = this.$refs.mallTree
    const mesTree: any = this.$refs.mesTree
    const mallNodes = mallTree ? mallTree.getCheckedNodes(false, true) : []
    const mesNodes = mesTree ? mesTree.getCheckedNodes(false, true) : []
    const menu_auth_mall = (mallNodes || []).map((n: any) => n.auth_key).filter((v: any) => !!v)
    const menu_auth_mes = (mesNodes || []).map((n: any) => n.auth_key).filter((v: any) => !!v)
    await apiMerchantMenuAuthSet({ menu_auth_mall, menu_auth_mes })
    await this.init()
  }

  created () {
    this.init()
  }
}
